import { DataAttributeDefinitions } from 'scrivito'

import { pisaActivityProjectRelationDataClass } from './Pisa/pisaActivityProjectRelationDataClass'

const attributes: DataAttributeDefinitions = {}

export const ActivityProjectRelation =
  pisaActivityProjectRelationDataClass(attributes)
